import React from 'react';
import Brand from '../../components/Brand';

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
function isRecent(createdAt) {
  if (!createdAt) return false;
  const ts = new Date(createdAt).getTime();
  if (Number.isNaN(ts)) return false;
  return Date.now() - ts < SEVEN_DAYS_MS;
}

/**
 * ParagraphWelcome — passages list.
 * Editorial 2-column grid of cards.
 */
function ParagraphWelcome({ passages, onSelect, onBack }) {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--paper)' }}>
      <header className="ink-header">
        <button className="btn btn--ghost btn--sm" onClick={onBack}>
          ← Modes
        </button>
        <Brand size="sm" />
        <span
          className="t-mono"
          style={{
            fontSize: 11,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: 'var(--ink-3)',
          }}
        >
          Reading · 阅读
        </span>
      </header>

      <div style={{ maxWidth: 880, margin: '0 auto', padding: '64px 32px' }}>
        <div className="t-eyebrow" style={{ marginBottom: 12 }}>
          Reading comprehension · 阅读理解
        </div>
        <h1
          className="t-display"
          style={{
            fontFamily: 'var(--font-han)',
            fontWeight: 500,
            marginBottom: 8,
          }}
        >
          读一段，<br />用心去理解。
        </h1>
        <p className="t-body" style={{ marginBottom: 40, fontSize: 17 }}>
          Pick a passage. Read it carefully. Then translate it in your own words.
        </p>

        <div
          className="pr-list"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 24,
          }}
        >
          {passages.map((p) => (
            <button
              key={p.id}
              onClick={() => onSelect(p)}
              style={{
                position: 'relative',
                textAlign: 'left',
                background: 'var(--card)',
                border: '1px solid var(--rule)',
                borderRadius: 12,
                padding: 24,
                cursor: 'pointer',
                color: 'var(--ink)',
                fontFamily: 'var(--font-sans)',
                transition: 'transform .15s, box-shadow .15s, border-color .15s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = 'var(--sh3)';
                e.currentTarget.style.borderColor = 'var(--ink-3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = '';
                e.currentTarget.style.boxShadow = '';
                e.currentTarget.style.borderColor = 'var(--rule)';
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginBottom: 24,
                }}
              >
                <span className="badge badge--mono">HSK {p.hskLevel}</span>
                {isRecent(p.createdAt) && <span className="badge badge--accent">New</span>}
              </div>
              <div
                style={{
                  fontFamily: 'var(--font-han)',
                  fontSize: 36,
                  lineHeight: 1.1,
                  letterSpacing: '0.03em',
                  marginBottom: 8,
                  color: 'var(--ink)',
                }}
              >
                {p.title}
              </div>
              <div className="pinyin" style={{ fontSize: 15, marginBottom: 24 }}>
                {p.subtitle}
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: 16,
                  paddingTop: 16,
                  borderTop: '1px solid var(--rule-2)',
                }}
              >
                <span className="t-small">
                  <span className="t-mono">{p.charCount}</span> characters
                </span>
                <span className="t-small">
                  <span className="t-mono">~{p.timeMinutes}</span> min read
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ParagraphWelcome;
